import React, { useContext } from 'react';
import './index.scss';
// import { Color } from 'csstype';
import { getFontSize } from '../../utils/style';
import intl from 'react-intl-universal';

export interface IStatisticsRow {
  n1: number;
  n2: number;
  fontColor?: string;
  fontSize?: number;
}
const StatisticsRow = (props: IStatisticsRow) => {
  const { fontSize, fontColor } = props;

  const theStyles: React.CSSProperties = {};
  Object.assign(theStyles, getFontSize(fontSize));

  // 父级的颜色优先
  fontColor && (theStyles.color = fontColor);

  return (
    <div className="statistics-row" style={theStyles}>
      <div className="one">
        <div style={{ flex: 1 }}>
          {intl.get('Photo')}:{props.n1}
        </div>
      </div>
      <div className="vertical-line" />
      <div className="one">
        <span>
          {intl.get('View')}:{props.n1 * 1 == 0 ? 0 : props.n2}
        </span>
      </div>
    </div>
  );
};

export default StatisticsRow;
